module.exports = __webpack_public_path__ + "img/clip.b8d65f02.svg";